import GlobalVars from '../subComponents/GlobalVar.jsx'

function fetchGet (url){
    return new Promise((resolve, reject)=>{
        resolve(fetch(`${GlobalVars.serverIp}${GlobalVars.serverPort}${url}`, {
            method: 'GET',
            mode: 'cors',
            keepalive: true,
            headers: {
                Accept: 'application.json',
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }})
            
            .then(resp =>  resp.json())
            .catch(resp => {return {"ERROR SERVER": resp}})
            )
    })
}

function fetchPost (url, body){
    return new Promise((resolve, reject)=>{
        resolve(fetch(`${GlobalVars.serverIp}${GlobalVars.serverPort}${url}`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                Accept: 'application.json',
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            },
            keepalive: true,
            body: JSON.stringify(body)
            })
            .then(resp => resp.json())
            .catch(resp => {return {"ERROR SERVER": resp}})
            )
    })
}


function fetchGetURL (url){
    return new Promise((resolve, reject)=>{
        resolve(fetch(`${url}`, {
            method: 'GET',
            mode: 'cors',
            keepalive: true,
            headers: {
                Accept: 'application.json',
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }})
            
            .then(resp =>  resp.json())
            .catch(resp => {return {"ERROR SERVER": resp}})
            )
    })
}

function fetchPostURL (url, body){
    return new Promise((resolve, reject)=>{
        resolve(fetch(`${url}`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                Accept: 'application.json',
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            },
            keepalive: true,
            body: JSON.stringify(body)
            })
            .then(resp => resp.json())
            .catch(resp => {return {"ERROR SERVER": resp}})
            )
    })
}


function fetchPutURL (url, body){
    return new Promise((resolve, reject)=>{
        resolve(fetch(`${url}`, {
            method: 'PUT',
            mode: 'cors',
            headers: {
                Accept: 'application.json',
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            },
            keepalive: true,
            body: JSON.stringify(body)
            })
            .then(resp => resp.json())
            .catch(resp => {return {"ERROR SERVER": resp}})
            )
    })
}

const fetchFunc = {
    fetchPost,
    fetchGet,
    fetchGetURL,
    fetchPostURL,
    fetchPutURL
}

export default fetchFunc;